import debounce from 'lodash.debounce';
import { request } from 'utils';

const onListEventsCache = {};
const requestsAcc = [];
let blockVisibilityCache = null;

const apiRequest = debounce(async () => {
  if (requestsAcc.length === 0) {
    return;
  }

  try {
    await request({
      url: `${process.env.APP_ANALYTIC_API_BASEURL}object-events`,
      method: 'post',
      data: requestsAcc,
    });
  } catch (error) {
    console.error('Analytics request error:', error);
  } finally {
    requestsAcc.length = 0;
  }
}, 2000);

const accApiRequest = ({ profileId, objectId, type, rate, currency }) => {
  requestsAcc.push({
    source: 'web',
    object_type: 'branch',
    owner_id: profileId,
    object_id: objectId,
    on_list: type === 'on_list' ? 1 : null,
    on_page: null,
    on_phone: null,
    on_route: type === 'on_route' ? 1 : null,
    currency,
    rate: rate
      ? Number(
          typeof rate === 'string' ? rate.replace(',', '.') : rate.toString()
        )
      : null,
    rate_kind: 'buy',
    dt: new Date().toISOString(),
    currency_exchanger_impression: type === 'on_list' ? 1 : null,
    currency_exchanger_click: type === 'on_route' ? 1 : null,
  });
  apiRequest();
};

export function analyticsEventPost({
  profileId,
  objectId,
  type,
  rate,
  currency,
}) {
  // Кешування для on_list подій, щоб не дублювати
  if (type === 'on_list') {
    const cacheKey = `${profileId}:${objectId}`;
    if (onListEventsCache[cacheKey]) {
      return () => {};
    }
    onListEventsCache[cacheKey] = true;
  }

  return async () => {
    try {
      accApiRequest({
        profileId,
        objectId,
        type,
        rate,
        currency,
      });
    } catch (err) {
      console.error('Analytics event error:', err);
    }
  };
}

export function analyticsEventsPostBatch(events, cacheKey) {
  // Кешування для блоку, щоб не відправляти повторно
  if (cacheKey && blockVisibilityCache === cacheKey) {
    return;
  }

  if (cacheKey) {
    blockVisibilityCache = cacheKey;
  }

  const eventsToSend = events
    .filter(event => {
      // Перевіряємо чи не була вже відправлена подія для цього обмінника
      const eventCacheKey = `${event.profileId}:${event.objectId}`;
      if (onListEventsCache[eventCacheKey]) {
        return false;
      }
      onListEventsCache[eventCacheKey] = true;
      return true;
    })
    .map(({ profileId, objectId, rate, currency }) => ({
      source: 'web',
      object_type: 'branch',
      owner_id: profileId,
      object_id: objectId,
      on_list: 1,
      on_page: null,
      on_phone: null,
      on_route: null,
      currency,
      rate: rate
        ? Number(
            typeof rate === 'string' ? rate.replace(',', '.') : rate.toString()
          )
        : null,
      rate_kind: 'buy',
      dt: new Date().toISOString(),
      currency_exchanger_impression: 1,
      currency_exchanger_click: null,
    }));

  if (eventsToSend.length === 0) {
    return;
  }

  request({
    url: `${process.env.APP_ANALYTIC_API_BASEURL}object-events`,
    method: 'post',
    data: eventsToSend,
  }).catch(error => {
    console.error('Analytics batch request error:', error);
  });
}
